import { useTheme } from '@mui/material';
import { ACCOUNT_TYPE_OBJECT, BANK_LIST_OBJECT } from 'app/helpers';
import { normalizeCpfCnpj } from 'app/utils/normalizer';
import { Heading4, TextM } from 'app/components';
import { PixType } from 'modules/customer/context/CustomerProvider/customer.interfaces';
import {
  ReviewSimulationBox,
  ReviewSimulationPreviewItem,
  ReviewSimulationPreviewItems,
  ReviewStepBox,
} from '../styles';
import { ReviewStepSimulationDivider } from './ReviewStepSimulationDivider';

interface SplitBeneficiary {
  taxpayer_id?: string;
  name?: string;
  amountString?: string;
  pix?: {
    key: string;
    key_type: string;
  };
  external_bank_account?: {
    ispb_code?: string;
    bank_account_type?: string;
    bank_branch?: string;
    bank_account?: string;
    bank_account_digit?: string;
  };
}

interface ReviewStepSplitBeneficiariesProps {
  beneficiaries: SplitBeneficiary[];
  getFormatedPix: (pixKey?: string, pixType?: PixType) => string;
}

const ReviewStepSplitBeneficiaries = ({
  beneficiaries,
  getFormatedPix,
}: ReviewStepSplitBeneficiariesProps) => {
  const theme = useTheme();

  if (beneficiaries.length === 0) {
    return null;
  }

  return (
    <>
      {beneficiaries.map((beneficiary) => (
        <ReviewStepBox
          key={`${beneficiary?.taxpayer_id}-${beneficiary?.amountString || ''}`}
          marginTop="0px"
          marginBottom="16px"
        >
          <Heading4
            style={{
              color: theme.palette.brand.secondary.base,
            }}
          >
            Conta do Beneficiário
          </Heading4>
          <ReviewSimulationBox>
            <ReviewSimulationPreviewItems>
              <>
                <ReviewSimulationPreviewItem>
                  <TextM
                    weight="Semibold"
                    style={{ color: theme.palette.brand.secondary.base }}
                  >
                    Nome
                  </TextM>
                  <TextM style={{ color: theme.palette.brand.secondary.base }}>
                    {beneficiary.name || '-'}
                  </TextM>
                </ReviewSimulationPreviewItem>
                <ReviewStepSimulationDivider theme={theme} />
              </>
              <>
                <ReviewSimulationPreviewItem>
                  <TextM
                    weight="Semibold"
                    style={{ color: theme.palette.brand.secondary.base }}
                  >
                    CPF / CNPJ
                  </TextM>
                  <TextM style={{ color: theme.palette.brand.secondary.base }}>
                    {beneficiary.taxpayer_id
                      ? normalizeCpfCnpj(beneficiary.taxpayer_id)
                      : '-'}
                  </TextM>
                </ReviewSimulationPreviewItem>
                <ReviewStepSimulationDivider theme={theme} />
              </>
              <>
                <ReviewSimulationPreviewItem>
                  <TextM
                    weight="Semibold"
                    style={{ color: theme.palette.brand.secondary.base }}
                  >
                    Chave Pix
                  </TextM>
                  <TextM style={{ color: theme.palette.brand.secondary.base }}>
                    {beneficiary.pix?.key
                      ? getFormatedPix(
                          beneficiary.pix.key,
                          beneficiary.pix.key_type as PixType,
                        )
                      : '-'}
                  </TextM>
                </ReviewSimulationPreviewItem>
                <ReviewStepSimulationDivider theme={theme} />
              </>
            </ReviewSimulationPreviewItems>
            <ReviewSimulationPreviewItems>
              <>
                <ReviewSimulationPreviewItem>
                  <TextM
                    weight="Semibold"
                    style={{ color: theme.palette.brand.secondary.base }}
                  >
                    Banco
                  </TextM>
                  <TextM style={{ color: theme.palette.brand.secondary.base }}>
                    {beneficiary.external_bank_account?.ispb_code
                      ? BANK_LIST_OBJECT[
                          beneficiary.external_bank_account.ispb_code
                        ]
                        ? `${
                            BANK_LIST_OBJECT[
                              beneficiary.external_bank_account.ispb_code
                            ]
                          } (${beneficiary.external_bank_account.ispb_code})`
                        : beneficiary.external_bank_account.ispb_code
                      : '-'}
                  </TextM>
                </ReviewSimulationPreviewItem>
                <ReviewStepSimulationDivider theme={theme} />
              </>
              <>
                <ReviewSimulationPreviewItem>
                  <TextM
                    weight="Semibold"
                    style={{ color: theme.palette.brand.secondary.base }}
                  >
                    Agência
                  </TextM>
                  <TextM style={{ color: theme.palette.brand.secondary.base }}>
                    {beneficiary.external_bank_account?.bank_branch || '-'}
                  </TextM>
                </ReviewSimulationPreviewItem>
                <ReviewStepSimulationDivider theme={theme} />
              </>
              <>
                <ReviewSimulationPreviewItem>
                  <TextM
                    weight="Semibold"
                    style={{ color: theme.palette.brand.secondary.base }}
                  >
                    Conta
                  </TextM>
                  <TextM style={{ color: theme.palette.brand.secondary.base }}>
                    {beneficiary.external_bank_account?.bank_account
                      ? `${beneficiary.external_bank_account.bank_account}${
                          beneficiary.external_bank_account?.bank_account_digit
                            ? `-${beneficiary.external_bank_account.bank_account_digit}`
                            : ''
                        }`
                      : '-'}
                  </TextM>
                </ReviewSimulationPreviewItem>
                <ReviewStepSimulationDivider theme={theme} />
              </>
              <>
                <ReviewSimulationPreviewItem>
                  <TextM
                    weight="Semibold"
                    style={{ color: theme.palette.brand.secondary.base }}
                  >
                    Tipo
                  </TextM>
                  <TextM style={{ color: theme.palette.brand.secondary.base }}>
                    {beneficiary.external_bank_account?.bank_account_type
                      ? ACCOUNT_TYPE_OBJECT[
                          beneficiary.external_bank_account.bank_account_type
                        ] ?? '-'
                      : '-'}
                  </TextM>
                </ReviewSimulationPreviewItem>
                <ReviewStepSimulationDivider theme={theme} />
              </>
            </ReviewSimulationPreviewItems>
          </ReviewSimulationBox>
        </ReviewStepBox>
      ))}
    </>
  );
};

export default ReviewStepSplitBeneficiaries;
